<template>
  <div class="page_user_message">
    <div class="head">
      <div class="head-background">
        <img :src="backgroundImg" alt="" style="width: 100%; height: 100%" />
      </div>
      <a-row class="row_margin">
        <a-col :span="2" class="head_info"> 用户名： </a-col>
        <a-col :span="6" class="head_info_text">
          {{ userInfo.username }}
        </a-col>
        <a-col :span="2" class="head_info"> 真实姓名： </a-col>
        <a-col :span="6" class="head_info_text">
          {{ userInfo.realName }}
        </a-col>
        <a-col :span="2" class="head_info"> 性别： </a-col>
        <a-col :span="6" class="head_info_text">
          {{ userInfo.sex }}
        </a-col>
      </a-row>
      <a-row class="row_margin">
        <a-col :span="2" class="head_info"> 邮箱： </a-col>
        <a-col :span="6" class="head_info_text">
          {{ userInfo.email }}
        </a-col>
        <a-col :span="2" class="head_info"> 手机： </a-col>
        <a-col :span="6" class="head_info_text">
          {{ userInfo.phone }}
        </a-col>
        <a-col :span="2" class="head_info"> 生日： </a-col>
        <a-col :span="6" class="head_info_text">
          {{ userInfo.birthday }}
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="2" class="head_info"> 账号类型： </a-col>
        <a-col :span="6" class="head_info_text">
          {{ userInfo.accountType }}
        </a-col>
        <a-col
          :span="2"
          class="head_info"
          v-if="userInfo.accountType != '普通用户'"
        >
          权限到期：
        </a-col>
        <a-col
          :span="4"
          class="head_info_text"
          v-if="userInfo.accountType != '普通用户'"
        >
          {{ userInfo.accountExpirationTime }}
        </a-col>
        <a-col :span="2" class="head_info_text">
          <a
            href="#"
            style="text-decoration: underline"
            v-if="userInfo.accountExpirationTime != null"
            >续费</a
          >
        </a-col>
        <a-col
          :span="2"
          class="head_info"
          v-if="userInfo.accountType == '个人开发者'"
        >
          项目上限：
        </a-col>
        <a-col
          :span="6"
          class="head_info_text"
          v-if="userInfo.accountType == '个人开发者'"
        >
          {{ projectLimit }}
        </a-col>
      </a-row>
    </div>
    <div class="content">
      <a-tabs :value="activeTab" @change="changeTab">
        <a-tab-pane key="1" tab="项目管理">
          <hm-search-card
            @toDetail="toProjectDetail"
            :cards="cards"
            :list_params="list_params"
            @viewProjectTagList="getProject"
          ></hm-search-card>
        </a-tab-pane>
        <a-tab-pane key="2" tab="所属团队">
          <Department
            :cards="teamList"
            :list_params="list_params"
            :total="teamTotal"
            @pageChange="pageChange"
            @toDetail="toTeamDetail"
        /></a-tab-pane>
        <a-tab-pane key="3" tab="所属企业">
          <Department
            :cards="companyList"
            :list_params="list_params"
            :total="companyTotal"
            @pageChange="pageChange"
             @toDetail="toCompanyDetail"
          />
        </a-tab-pane>

        <a-tab-pane key="4" tab="访问令牌">
          <AccessTokens
          />
        </a-tab-pane>
        <a-button
          type="primary"
          v-if="activeTab == 1"
          class="tabs_button"
          slot="tabBarExtraContent"
          @click="goAddProject"
        >
          创建项目
        </a-button>
        <a-button
          type="primary"
          v-if="activeTab == 2"
          class="tabs_button"
          slot="tabBarExtraContent"
          @click="openModal('2')"
        >
          创建团队
        </a-button>
        <a-button
          type="primary"
          v-if="activeTab == 3 && userInfo.accountType == '企业'"
          class="tabs_button"
          slot="tabBarExtraContent"
          @click="openModal('1')"
        >
          创建企业
        </a-button>
      </a-tabs>
      <div class="pagination" v-if="activeTab == 1">
        <a-pagination
          :current="list_params.pageNo"
          @change="pageChange"
          size="large"
          :total="projectTotal"
          :pageSize="list_params.pageSize"
          show-quick-jumper
        />
      </div>
    </div>
    <a-modal v-model="createVisible" title="填写信息" @ok="handleCeate" cancelText="取消" okText="确认创建">
      <a-form-model layout="horizontal" :model="form">
        <a-form-model-item label="名称">
          <a-input v-model="form.departName" placeholder="请输入名称" />
        </a-form-model-item>
        <a-form-model-item label="编码">
          <a-input v-model="form.orgCode" placeholder="请输入编码" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import AccessTokens from "@/components/AccessTokens";
import HmSearchCard from "@/components/HmSearchCard";
import Department from "@/components/Department";
import global_ from "@/utils/global.js";
import sysUserApi from "@/request/api-manager/sysUser.js";
import companyApi from "@/request/api-manager/company.js";
import viewProjectTagApi from "@/request/api-manager/viewProjectTag.js";
export default {
  data() {
    return {
      activeTab: 1,
      backgroundImg: require("@/assets/user-message/user.png"),
      cards: [],
      teamList: [],
      companyList: [],
      list_params: {
        pageSize: 10,
        pageNo: 1,
      },
      companyTotal: 0,
      projectTotal: 0,
      teamTotal: 0,
      userInfo: {},
      projectLimit: "",
      createVisible: false,

      form: {
        departName: '',
        orgType: 1,
        orgCode: '',
        departOrder: 0
      },

    };
  },
  components: {
    HmSearchCard,
    Department,
    AccessTokens
  },
  mounted() {
    this.getTeam();
    this.getCompany();
    this.getAccountInfo();
    this.getProject();
  },
  methods: {
    toProjectDetail(projectId) {
      this.$router.push({
        path: "/component/list",
        query: { projectId: projectId },
      });
    },
    changeTab(key) {
      this.list_params.pageNo = 1;
      this.activeTab = key;
    },
    pageChange(page) {
      let self = this;
      self.list_params.pageNo = page;
    },
    getAccountInfo() {
      sysUserApi.getAccountInfo().then((res) => {
        //帐户类型
        res.result.accountType = this.correspondingRelation(
          res.result.accountType,
          global_.accountTypeParams
        );
        //性别
        res.result.sex = this.correspondingRelation(
          res.result.sex,
          global_.sexParams
        );
        //项目上限
        res.result.projectNum = res.result.projectNum
          ? res.result.projectNum
          : "0";
        this.projectLimit =
          res.result.projectNum + "/" + res.result.accountProjectLimit;
        //上限
        this.userInfo = res.result;
        console.log(this.userInfo,'this.userInfo');
      });
    },
    getProject() {
      viewProjectTagApi.listByUser(this.list_params).then((res) => {
        this.cards = res.result.records;
        this.projectTotal = res.result.total;
      });
    },
    getTeam() {
      sysUserApi.listTeamByUser().then((res) => {
        this.teamList = res.result.records;
        this.teamTotal = res.result.total;
      });
    },
    getCompany() {
      sysUserApi.listCompanyByUser().then((res) => {
        this.companyList = res.result.records;
        this.companyTotal = res.result.total;
      });
    },
    toTeamDetail(teamId) {
      this.$router.push({
        path: "/team-page/index",
        query: { teamId: teamId },
      });
    },
    toCompanyDetail(companyId){
      this.$router.push({
        path: "/company-page/index",
        query: { companyId: companyId },
      });
    },
    handleCeate() {
      this.form.accountId = this.userInfo.accountId
      companyApi.createTeam(this.form).then(res => {
        console.log(res,'resresresresresres');
        this.createVisible = false
      })

    },
    goAddProject() {
      this.$router.push({ path: '/add-project' })
    },
    openModal(type) {
      this.createVisible = true
      this.form.orgType = type
    }
  },
};
</script>
<style scoped>
@import "./index.css";
</style>